export default class SelectLocations {

    constructor() {

        this.bindUIActions();

    }

    bindUIActions() {

        if($('#map-canvas').length != 0) {
            let geocoder, map, marker;

            // Basic map setup
            function initialize() {
                geocoder = new google.maps.Geocoder();

                const mapStyles = [
                    {
                      "featureType": "administrative.land_parcel",
                      "elementType": "labels",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "labels",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "labels",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "labels",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                ];
                
                const mapOptions = {
                    zoom: 16,
                    styles: mapStyles,
                }

                map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);

                // On init also run the selectAddress function
                selectAddress();
            }

            // Geocode the address - pass in the address
            function geocodeIt(address) {
                geocoder.geocode( { 'address': address}, function(results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {

                        const pin = document.getElementById('map-pin').src;
                        map.setCenter(results[0].geometry.location);

                        marker = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location,
                            animation: google.maps.Animation.DROP,
                            opacity: 1.0,
                            icon: pin
                        });

                    } else {
                        alert('Geocode was not successful for the following reason: ' + status);
                    }
                });
            }

            function selectAddress() {
                let officeLocations = $('#office-locations'),
                    address = officeLocations.find('option:selected').val();
                // Add a marker of the default selected option
                geocodeIt(address);

                // On 'changing' the select remove current marker and then add the newly selected one
                officeLocations.on('change', function() {
                    address = officeLocations.find('option:selected').val();
                    marker.setMap(null);
                    geocodeIt(address);
                });
            }

            function drop() {
                setTimeout(function() {
                    addMarker();
                },200);
            }

            $(window).on('load', function(){
                initialize();
            });

            // Change the location info on select change
            let selectLocation = () => {

                let $selectedLocation = $('#office-locations option').filter(':selected').val();
                let $locations = $('div[data-office-location]');
                let $locationsArray = $locations.toArray();

                $locationsArray.forEach((loc) => {
                    if(loc.getAttribute('data-office-location') === $selectedLocation) {
                        loc.classList.remove('hidden');
                    } else {
                        loc.classList.add('hidden');
                    }
                });

            }

            let onSelectChange = function() {
                selectLocation();
            }

            $('#office-locations').change(onSelectChange);
        }

    }
}

new SelectLocations();